export function getQuestionPoints(state, question){
}
export function getQuestionById(state, id){
	return state.questions.find( q => q.id === id );
}
export function getResultById(state, id){
	return state.results.find( r => r.id === id );
}
export function getActiveQuestion(state){
	if ( state.questions[state.activeQuestion] ){
		return state.questions[state.activeQuestion];
	}
	return false;
}
export function getActiveResult(state){
	if ( state.activeResult !== null ) {
		if ( state.results[state.activeResult] ){
			return state.results[state.activeResult];
		}
	}
	return false;
}